<div class="button-loader">
    <ng-content *ngIf="!isLoading else spinner"></ng-content>
</div>

<ng-template #spinner>
    <div class="btn button-loader__progressbar">
        <span class="spinner spinner-inline"></span>
    </div>
</ng-template>
